export const GET_USAGE_HISTORY = 'GET_USAGE_HISTORY';
export const GET_CUSTOMER_USAGE_BY_DATE = 'GET_CUSTOMER_USAGE_BY_DATE';
export const GETTING_BY_DATE_STARTS = 'GETTING_BY_DATE_STARTS';
export const GETTING_BY_DATE_STOPS = 'GETTING_BY_DATE_STOPS';

export const GET_USAGE_STATISTICS = 'GET_USAGE_STATISTICS';
